import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { arcadiaGreenButtonService } from "../services/arcadia-green-button.service"

type ResumeArcadiaGreenButtonUsageParams = {
  proposalId: string
  siteId: string
}

export const useResumeArcadiaGreenButtonUsage = (): UseMutationResult<
  void,
  unknown,
  ResumeArcadiaGreenButtonUsageParams,
  unknown
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, siteId }) =>
      arcadiaGreenButtonService.resumeProposalUsage(siteId, proposalId),
    onSuccess: (_data, { proposalId, siteId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.arcadiaGreenButton.site(siteId),
      })
      // Resuming re-applies the same import, so the drawer's import id never
      // changes and nothing else re-reads the derived views. Without this the
      // usage tabs keep describing the consumption the proposal just left.
      void queryClient.invalidateQueries({
        queryKey: queryKeys.proposalConsumption.insights(proposalId),
      })
      void queryClient.invalidateQueries({
        queryKey: queryKeys.proposalConsumption.selection(proposalId),
      })
    },
  })
}
